module.exports = __webpack_public_path__ + "static/media/argument.ee02ad51.jpg";